import Model, { attr } from '@ember-data/model';
import { computed, get } from '@ember/object';

const EMAIL_TYPE_LABELS = {
  1: 'New Donations',
  2: 'Weekly Update',
  3: 'Approve Forwarding',
  4: 'Other',
  5: 'Contact Date Alert',
};

export default Model.extend({
  userId: attr(),
  emailTypeId: attr('number'),
  emailTypeLabel: computed('emailTypeId', function () {
    return EMAIL_TYPE_LABELS[this.emailTypeId];
  }),
  sentAt: attr('date'),
  openedAt: attr('date'),
  bounced: attr('boolean'),
  bouncedDescription: attr(),
});
